import { Button, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import theme from "../../theme/theme";

const PrimaryButton = ({
  text,
  onClick,
  type,
  mt,
  icon,
  bgLight,
  disabled,
  isLoading,
  height,
  width,
  secondary,
}: any) => {
  const bg = useColorModeValue(
    bgLight || theme.colors.dark.accent.primary,
    theme.colors.light.accent.primary
  );
  const color = useColorModeValue(
    theme.colors.light.accent.primary,
    theme.colors.dark.accent.primary
  );

  const borderColor = useColorModeValue(
    theme.colors.light.border.primary,
    theme.colors.dark.border.primary
  );

  const bgLightBorderColor = useColorModeValue(
    "transparent",
    theme.colors.dark.border.primary
  );

  const secondaryColor = useColorModeValue("#000", "#E4E4E4");
  return (
    <Button
      height={height}
      width={width}
      _hover={{ bg: secondary ? "transparent" : bg }}
      p="24px 10px"
      w={width ? width : "100%"}
      bg={secondary ? "transparent" : bg}
      color={secondary ? secondaryColor : color}
      mt={mt || "40px"}
      borderRadius={"12px"}
      border="1px solid"
      borderColor={
        secondary ? secondaryColor : bgLight ? bgLightBorderColor : borderColor
      }
      onClick={onClick}
      type={type}
      gap="10px"
      alignItems={"center"}
      isDisabled={disabled}
      isLoading={isLoading}
    >
      {text} {icon}
    </Button>
  );
};

export default PrimaryButton;
